module.exports = __webpack_public_path__ + "static/img/special_win_prize.09f6e10.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/daily/special_win_prize.png
// module id = 551
// module chunks = 1